export const testAttributes = {
    ACCOUNTS_LIST_CONTAINER: 'accounts-list-container',
};
